// Pagina prodotto: miniature cliccabili; i pulsanti delle opzioni scelgono la variante e aggiornano
// id nel form, prezzo, prezzo di riferimento Omnibus, badge, pulsante, immagine e ?variant= nell'URL.
// I valori che, con le altre opzioni scelte, portano a varianti esaurite o inesistenti vengono barrati (.na).
document.querySelectorAll('[data-product]').forEach(function (root) {
  var img = root.querySelector('.prod-img');
  function show(src) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
  }
  function set(sel, text) {
    var el = root.querySelector(sel);
    if (!el) return;
    el.textContent = text;
    el.hidden = !text;
  }
  root.querySelectorAll('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () { show(b.dataset.src); });
  });

  var data = root.parentNode.querySelector('[data-variants]');
  if (!data) return;
  data = JSON.parse(data.textContent);
  var groups = root.querySelectorAll('.opts'), idInput = root.querySelector('[data-variant-id]'),
      btn = root.querySelector('[data-add]'), qty = root.querySelector('#qty');

  function selected() {
    return Array.prototype.map.call(groups, function (g) {
      var r = g.querySelector('input:checked');
      return r ? r.value : null;
    });
  }
  function find(opts) {
    return data.variants.find(function (x) {
      return x.options.every(function (o, i) { return o === opts[i]; });
    });
  }
  function markUnavailable() {
    var sel = selected();
    groups.forEach(function (g, i) {
      g.querySelectorAll('input').forEach(function (r) {
        var test = sel.slice();
        test[i] = r.value;
        var t = find(test);
        r.parentNode.classList.toggle('na', !t || !t.available);
      });
    });
  }
  groups.forEach(function (g) {
    g.addEventListener('change', function () {
      var v = find(selected());
      markUnavailable();
      if (!v) { btn.disabled = true; btn.textContent = data.t.unavailable; return; }
      idInput.value = v.id;
      set('[data-price-out]', v.price);
      set('[data-compare-out]', v.compare);
      set('[data-pct-out]', v.pct);
      set('[data-low-out]', v.low);
      btn.disabled = !v.available;
      btn.textContent = v.available ? data.t.add : data.t.sold_out;
      if (qty) {
        if (v.max) { qty.max = v.max; if (+qty.value > v.max) qty.value = v.max; } else qty.removeAttribute('max');
      }
      show(v.img);
      var u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(null, '', u);
    });
  });
  markUnavailable();
});
